module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "tlHeader",
    style: (_vm.getStyle),
    attrs: {
      "id": "rulerHeader"
    }
  }, [_c('span', {
    staticClass: "tlHeaderText"
  }, [_vm._v("教室/時刻")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b32a1496", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b32a1496"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/timetable/SpRulerHeader.vue
// module id = 745
// module chunks = 0